export default __webpack_public_path__ + "static/media/Calibre-Regular.7ae611bd.ttf";